// 组件
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
// api
import { getPersonalOrders } from '@/api/purchaseAndSaleAPI'
import { orderDetailCommonInfoV2 } from '@/api/domain/orders'
// 其他
import { checkBeforeReturnCar } from '@/api/domain/finance'
import { PERSONAL_ADD_PATH } from '@/pages/orders/orderRenewal/list/config'
import { operateMaxShowLength } from '@/store/dict/config'
import { ORDER_STATE } from '@/store/dict/order.js'
import { CATEGORY_CODE_MAP, ONE_KEY_CHANGE_STATUS } from '@/store/dict/rentPlanDict.js'
import selectOptionDict from '@/store/dict/selectOptionDict'

// 个人租赁订单配置
export default function personalConfig() {
  return {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            remoteMethod: this.carRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            options: { // 下拉数据
              label: 'plateNo',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const carItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'carId')
                this.carConditionList = carItem?.elConfig?.options?.list
              },
            },
          },
        }, {
          el: 'select',
          itemConfig: {
            label: '司机姓名',
            prop: 'customerId',
          },
          elConfig: {
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            remoteMethod: this.customerRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            options: { // 下拉数据
              label: 'customerName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const customerItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
                this.customerConditionList = customerItem?.elConfig?.options?.list
              },
            },
          },
        }, {
          el: 'select',
          itemConfig: {
            label: '到期时间',
            prop: 'rentEndTimeRange',
          },
          elConfig: {
            defaultValue: '30',
            clearable: true,
            placeholder: '请选择',
            options: {
              label: 'label',
              value: 'value',
              list: [
                { label: '近一个月', value: '30' },
                { label: '近两周', value: '14' },
                { label: '近一周', value: '7' },
              ],
            },
          },
          isShow: false,
        }, {
          el: 'select',
          itemConfig: {
            label: '所属司管',
            prop: 'driverManagerId',
          },
          elConfig: {
            filterable: true,
            clearable: true,
            placeholder: '请选择司管人员',
            options: { // 下拉数据
              label: 'userName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const dmItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'driverManagerId')
                this.dmConditionList = dmItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '销售经理',
            prop: 'salesManagerId',
          },
          elConfig: {
            filterable: true,
            clearable: true,
            placeholder: '请选择销售经理',
            options: {
              label: 'salesManagerName',
              value: 'salesManagerId',
              list: [],
            },
            events: {
              change: () => {
                const smItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'salesManagerId')
                this.salesManagerConditionList = smItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入订单ID',
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '运营城市',
            prop: 'adcode',
          },
          elConfig: {
            clearable: true,
            filterable: true,
            reserveKeyword: true,
            defaultFirstOption: true,
            placeholder: '请选择',
            options: {
              label: 'city',
              value: 'adcode',
              list: [],
            },
          },
        }, {
          el: 'select',
          itemConfig: {
            label: '租赁类别',
            prop: 'rentCategory',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        }, {
          el: 'select',
          itemConfig: {
            label: '网约钱包支付签约状态',
            prop: 'walletWithholdState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOptionDict.walletWithholdState, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '支付宝支付签约状态',
            prop: 'personalWithholdState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOptionDict.alipayWithholdStateNew, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '合同备案状态',
            prop: 'contractFilingState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOptionDict.contractFilingStateList, true),
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'TheOrderStart',
          },
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单结束时间',
            prop: 'rentFinIsh',
          },
          elConfig: {
            clearable: true,
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '订单ID',
            fixed: 'left',
            width: '110',
          },
          render: ({ row }) => {
            if (!this.judgePermission('under_lease_order_rent_detail')) return row.id
            return <span class="a-hover-link" onClick={() => this.toOrderDetailPage({ id: row.id, deptId: row.deptId })}>{row.id}</span>
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
        },
        {
          name: 'city',
          columnProps: {
            prop: 'city',
            label: '运营城市',
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '司机姓名',
            width: 110,
          },
          render: ({ row }) => {
            const idCard = this.idCardCache[row.id]
            const fetchIdCard = () => {
              if (idCard !== undefined) return
              this.$set(this.idCardCache, row.id, null)
              orderDetailCommonInfoV2({ orderId: row.id }).then(({ code, data }) => {
                if (code === 1 && data?.idCard) {
                  this.$set(this.idCardCache, row.id, data.idCard)
                }
              })
            }
            return (
              <el-tooltip placement="top" effect="dark">
                <div slot="content" style="min-width: 160px;">{idCard ? `身份证：${idCard}` : '加载中...'}</div>
                <span onMouseenter={fetchIdCard} style="cursor: pointer; display: inline-block; width: auto">{row.customerName}</span>
              </el-tooltip>
            )
          },
        },
        {
          name: 'rentCategoryName',
          columnProps: {
            prop: 'rentCategoryName',
            label: '租赁类别',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金',
            width: '100',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '150',
            align: 'left',
          },
          render: ({ row }) => {
            if (row.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
              return '--'
            }
            return `${row.deposit === null ? '0.00' : row.deposit}` +
            '/' +
            `${row.receivedDeposit}`
          },
        },
        {
          name: 'startDate',
          columnProps: {
            label: '合同周期',
            prop: 'startDate',
          },
          render: ({ row }) => {
            if (row.startDate) {
              return `${row.startDate} ~ ${row.contractEndDate}`
            }
            return '--'
          },
        },
        {
          name: 'contractFilingStateName',
          columnProps: {
            prop: 'contractFilingStateName',
            label: '合同备案状态',
            width: '120',
          },
        },
        {
          name: 'walletWithholdState',
          columnProps: {
            width: '110',
            label: '网约钱包支付',
          },
          render: ({ row }) => {
            return (
                <div>
                  {row.dayAndWeekWalletWithhold?.status !== undefined &&
                    row.dayAndWeekWalletWithhold?.status !== null
                    ? selectOptionDict.walletWithholdState[row.dayAndWeekWalletWithhold?.status]
                    : '--'}

                  {row.dayAndWeekWalletWithhold?.noOpenReason &&
                    <el-tooltip placement="top-start">
                      <div slot="content">{row.dayAndWeekWalletWithhold.noOpenReason}</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  }
                </div>
            )
          },
        },
        {
          name: 'personalWithholdState',
          columnProps: {
            width: '100',
            label: '支付宝支付',
          },
          render: ({ row }) => {
            const { reason } = row.personalWithholdState
            const parseReason = reason ? JSON.parse(reason) : []

            return this.$createElement(
              'div',
              [
                row.personalWithholdState?.signState !== undefined
                  && row.personalWithholdState?.signState !== null
                  ? selectOptionDict.alipayWithholdStateNew[row.personalWithholdState?.signState]
                  : '- -',
                // 判断是否有提示文字
                reason
                  ?
                  this.$createElement(
                    'el-tooltip',
                    {
                      props: {
                        placement: 'top-start',
                        effect: 'dark',
                      },
                    },
                    [
                      this.$createElement('i', { class: 'el-icon-question' }),
                      this.$createElement('div', {
                        slot: 'content',
                      },
                      [
                        parseReason.map((item) => this.$createElement('p', item)),
                      ]),
                    ],
                  ) : '',
              ],
            )
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '订单创建时间',
            width: '160',
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            width: '100',
            formatter: (row) => selectOptionDict.leaseOrderState[row.state],
          },
        },
        {
          name: 'source',
          columnProps: {
            prop: 'source',
            label: '下单方式',
            formatter: (row) =>
              selectOptionDict.source[row.source],
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            width: '110',
            label: '订单创建人',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          type: 'operate',
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            // 待履约
            //   --订单待确认 0
            //   --发车待验车 1500
            // 履约中  state === 2500
            // 退车核算
            //   --退车待验车 3500
            //   --订单待核算 4500
            // 已关闭 state === 5500
            const arr = []
            if (this.judgePermission('under_lease_order_rent_terminate_agreement')) {
              arr.push(
                {
                  label: '退车解约',
                  action: async () => {
                    const { code } = await checkBeforeReturnCar({
                      orderId: row.id,
                    })
                    if (code === 1) {
                      this.toReturnCarPage(row)
                    }
                  },
                },
              )
            }
            arr.push({
              label: '资金划扣',
              action: async () => this.toOrderDetailPage({ id: row.id, type: '6' }, '#sign'),
            })
            // judgeDayWithNow没到合同开始时间，不显示转租赁按钮
            if (this.judgePermission('under_lease_order_rent_turn_rent_mode') && [3].includes(row.rentCategory)) {
              arr.push(
                { label: '转租赁模式', action: () => this.toOrderRentTurnRentModeConfirm(row) },
              )
            }
            if (this.judgePermission('under_lease_order_rent_transfer_car')) {
              arr.push(
                { label: '临时换车', action: () => this.toOrderTransferCar(row, 1) },
              )
            }
            if (this.judgePermission('rent_order_renewal') && row.showRenewal) {
              arr.push({
                label: '订单续约',
                action: () => {
                  this.$router.push({
                    path: PERSONAL_ADD_PATH,
                    query: { oldOrderId: row.id },
                  })
                },
              })
            }

            if (row.state === ORDER_STATE.RENTING
              && [ONE_KEY_CHANGE_STATUS.INITIAL,
                ONE_KEY_CHANGE_STATUS.APPROVAL].includes(row.changeCarState)
              && this.judgePermission('rentIngOneKeyChangeCar')) {
              arr.push({
                label: '一键换车',
                action: () => this.showOneKeyChangeCar(row, 'selectNewCar'),
              })
            }

            if (row.state === ORDER_STATE.RENTING
                && row.changeCarState === ONE_KEY_CHANGE_STATUS.CHECKING
                && this.judgePermission('rentIngOneKeyChangeCar')
            ) {
              arr.push({
                label: '换车验车',
                action: () => this.showOneKeyChangeCar(row, 'checkAndReplaceCar'),
              })
            }

            if (row.state === ORDER_STATE.RENTING
                && row.changeCarState === ONE_KEY_CHANGE_STATUS.SIGN_CONTRACT
                && this.judgePermission('rentIngOneKeyChangeCar')
            ) {
              arr.push({
                label: '签署合同',
                action: () => this.showOneKeyChangeCar(row, 'signContract'),
              })
            }
            return arr
          },
        },
      ],
      apiFn: getPersonalOrders,
    },
  }
}
